export const isValidCustomerTpid = (tpid) => /^[0-9]{4,}$/.test(tpid.trim());
